import React, { useEffect } from 'react';
import { osName } from 'react-device-detect';

function checkDevice(os) {
  os = os.toLowerCase();

  switch (os) {
    case 'ios':
      // path to app domain
      window.location = `${window.env.REACT_APP_OPEN_APP_URL}/download_app`;
      break;
    case 'android':
      // path to app link
      setTimeout(function () {
        window.location =
          'https://play.google.com/store/apps/details?id=com.dtf.orderapp';
      }, 1000);
      window.location = 'https://dintaifung.app';
      break;
    default:
      window.location = 'https://play.google.com/store/apps/details?id=com.dtf.orderapp';
      break;
  }
}

const OpenOrDownloadApp = props => {
  useEffect(() => {
    checkDevice(osName);
  }, []);
  return null
};

export default OpenOrDownloadApp;
